<template>
  <div class="common-home-content space_pl space_pr" :class="is_app?'common-home-content-pb':''" v-show="show">
    <div class="detail-header" v-if="is_app"><van-icon class="back" name="arrow-left"  @click="pageback" />添加患者</div>
    <div class="doctor-info">
      <div class="info">
        <div class="portrait">
          <van-image
            width="100%"
            height="100%"
            round
            fit="cover"
            alt=""
            :src="doctorData.avatar"
          />
        </div>
        <p class="name">{{doctorData.name}}的医馆</p>
        <p class="title">中医{{doctorData.department}} {{doctorData.title}}</p>
      </div>
    </div>
    <div class="qcode-content">
      <p class="text">“</p>
      <p class="text" style="text-indent: 15px;">长按或扫描二维码下载</p>
      <p class="text" style="text-indent: 15px;">在家庭中医馆中找到我</p>
      <p class="text" style="text-align: right;">”</p>
      <img :src="doctorData.qr_code" alt="">
    </div>
    <div class="diseases-content">
      <p class="title">主治</p>
      <ul class="diseases-ul clearfix">
        <li
          class="fl"
          v-for="(child, index) in doctorData.diseases"
          :key="index"
        >{{child.name}}</li>
      </ul>
    </div>
    <div class="introduction-content">
      <p class="title">擅长</p>
      <p class="summary">{{doctorData.skill}}</p>
    </div>
    <div class="introduction-content">
      <p class="title">简介</p>
      <p class="summary">{{doctorData.introduction}}</p>
    </div>
    <div class="fixed-button" v-if="is_app">
      <button @click="sendShare">分 享</button>
    </div>
  </div>
</template>
<script>
import http from '../../util/iapetusApiConfig'
import {deviceType} from '../../util/deviceType'
export default {
  data() {
    return {
      show: false,
      doctorData: {},
      doctor_id: 1,
      token: '',
      title: '家庭中医馆',
      is_app: deviceType.isApp
    };
  },
  metaInfo(){
    return {title: this.title};
  },
  created() {
    var user_info = this.$appUtils.appData();
    if(user_info){
        this.token = user_info.token;
    }
    this.doctor_id = this.$route.params.id;
    this.getDate();
    window.appBack = ()=> this.pageback();
  },
  methods: {
    getDate() {
      let that = this;
      http.get("/doctors/"+that.doctor_id, {
        headers: {
            "Authorization": that.token
        }
      }).then(function(res) {
          that.doctorData = res.data.data;
          that.title = that.doctorData.name + '医生的中医工作室';
          that.show = true;
          that.$appUtils.appCloseLoadingView();
      });
    },
    sendShare(){
      that.$appUtils.appShare({
        'title': doctorData.name + '医生的中医工作室',
        'description': '通过二维码下载并关注我的工作室，随时向我发起在线咨询。',
        'description2': '邀请您关注' + doctorData.name + '医生的中医工作室|家庭中医馆',
        'url': window.location.href,
        'qr_code': doctorData.qr_code,
        'imgurl': doctorData.avatar
      });
    },
    pageback(){
        that.$appUtils.appCloseWebView();
    }
  },
};
</script>
<style lang="scss" scoped>
.detail-header{
  width: 100%;
  line-height: 50px;
  font-size:18px;
  font-family: PingFang-SC-Heavy;
  font-weight:800;
  color:rgba(255,255,255,1);
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  .back{
    line-height: 50px;
    margin: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 12px;
  }
}
.common-home-content{
  width: 100%;
  box-sizing: border-box;
  background: url('../../assets/images/doctor/bg.png') no-repeat;
  background-size: contain;
  background: none\9;
  padding-bottom: 30px;
}
.common-home-content-pb{
  padding-bottom: 70px;
}
.doctor-info{
  width: 100%;
  box-sizing: border-box;
  padding-top: 20.533333%;
  .info{
    width: 100%;
    box-sizing: border-box;
    padding: 40px 15px 40px 103px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 6px 1px rgba(35,24,21,0.18);
    border-radius:4px;
    position: relative;
    .portrait{
      width: 74px;
      height: 74px;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 15px;
    }
    .name{
      line-height: 16px;
      font-size:16px;
      font-family: PingFang-SC-Bold;
      font-weight:bold;
      color:rgba(51,51,51,1);
    }
    .title{
      margin-top: 25px;
      font-size:12px;
      font-family:PingFang-SC-Medium;
      font-weight:500;
      color:rgba(51,51,51,1);
    }
  }
}
.qcode-content{
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
  padding: 32px 0 32px 10px;
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 6px 1px rgba(35,24,21,0.18);
  border-radius:4px;
  position: relative;
  .text{
    width: 195px;
    font-size:16px;
    font-family:PingFang-SC-Medium;
    font-weight:500;
    color:#333333;
    line-height:24px;
  }
  img{
    width: 90px;
    height: 90px;
    margin: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 20px;
  }
}
.diseases-content{
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
  padding: 20px 10px;
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 6px 1px rgba(35,24,21,0.18);
  border-radius:4px;
  .title{
    line-height: 18px;
    font-size:18px;
    font-family:PingFang-SC-Bold;
    font-weight:bold;
    color:rgba(51,51,51,1);
  }
  .diseases-ul{
    margin-top: 15px;
    width: 100%;
    box-sizing: border-box;
    & > li{
      margin-top: 10px;
      margin-right: 6px;
      display: inline-block;
      padding: 0 10px;
      line-height: 22px;
      font-size:14px;
      font-family: PingFang-SC-Medium;
      font-weight:500;
      color:rgba(140,62,32,1);
      background:rgba(245,187,126, 0.15);
      border-radius:11px;
    }
    & > li:last-child{
      margin-right: 0;
    }
  }
}
.introduction-content{
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
  padding: 20px 10px 15px 10px;
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 6px 1px rgba(35,24,21,0.18);
  border-radius:4px;
  .title{
    line-height: 18px;
    font-size:18px;
    font-family:PingFang-SC-Bold;
    font-weight:bold;
    color:rgba(51,51,51,1);
  }
  .summary{
    margin-top: 20px;
    font-size:14px;
    font-family:PingFang-SC-Medium;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:24px;
    text-align:justify;
  }
}
.fixed-button{
  width: 100%;
  box-sizing: border-box;
  padding: 3px 40px;
  position: fixed;
  left: 0;
  bottom: 0;
  background-color: #fff;
  & > button{
    display: block;
    width: 100%;
    box-sizing: border-box;
    line-height: 43px;
    font-size:17px;
    font-family: PingFang-SC-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);
    text-align: center;
    background:rgba(172,76,56,1);
    border-radius:4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/doctor/businesscard.vue